<template>
  <div v-if="visible" class="modal" :class="{ 'is-active': visible }">
    <div class="modal-background" @click="free >= 2 ? hide() : false"></div>
    <div class="modal-content">
      <transition
        name="custom-classes-transition"
        enter-active-class="pulse-fast-once"
        appear
      >
        <div class="box">
          <div class="has-text-right dismiss-text">
            <a @click.stop="hide()">Close</a>
          </div>

          <h2 class="title is-2">Hi there!</h2>

          <p v-if="free >= 5">
            Happy times, you can still add
            <strong>{{ free }}</strong> more computers for free!
          </p>

          <p v-else-if="free <= 2 && free > 0">
            It's starting to get a little tight in here, but you can still add
            <strong>{{ free }}</strong> more computer<span v-if="free > 1"
              >s</span
            >.
          </p>

          <p v-if="free >= 0">
            We hope that you're enjoying Deployify so far 😄
          </p>

          <p v-if="free == 0">
            <strong> You have now reached the limit of this trial.</strong>
          </p>

          <div v-if="free < 0" class="content">
            <p>
              <strong>
                You have exceeded the limits of this trial and need to take
                action to proceed using this service.</strong
              >
            </p>

            <ul>
              <li>
                Remove computers until you reach the max limit of
                {{ total }} computers
              </li>
            </ul>

            <p>
              After the above, the service "DeploymentClient" needs to be
              restarted on the computers left in Deployify (to be able to
              reconnect).
            </p>
          </div>

          <div class="notification is-success mt-5">
            <h3 class="title is-4">
              Want your own unlimited Deployify service?
            </h3>

            <p>
              Have your own unlimited Deployify service up and running in
              minutes.
            </p>

            <div class="is-flex is-justify-content-center">
              <a href="https://licensing.deployify.io" target="_blank"
                ><button
                  class="button is-success is-light is-inverted is-rounded"
                >
                  Let's go!
                </button></a
              >
            </div>
          </div>

          <slot></slot>
        </div>
      </transition>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="hide()"
    ></button>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },

  computed: {
    free() {
      return this.$store.state.settings.licenseInfo.free;
    },

    total() {
      return this.$store.state.settings.licenseInfo.total;
    },

    visible() {
      return (
        this.$store.state.settings.licenseInfo &&
        this.$store.state.settings.isLicenseConversionModalVisible &&
        !this.$store.state.settings.licenseInfo.active
      );
    },
  },

  methods: {
    hide() {
      this.$store.commit("settings/setLicenseConversionVisible", false);
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: fit-content;
  max-width: 750px;
}

.dismiss-text {
  font-size: 11px;
}
</style>
